import { render, staticRenderFns } from "./MemberHead.vue?vue&type=template&id=418b6afb&scoped=true"
import script from "./MemberHead.vue?vue&type=script&lang=js"
export * from "./MemberHead.vue?vue&type=script&lang=js"
import style0 from "./MemberHead.vue?vue&type=style&index=0&id=418b6afb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418b6afb",
  null
  
)

export default component.exports